import React from 'react'
import { Navbar } from '../components/Navbar'
import { Hero } from '../components/Hero'
import { HowWe } from '../components/HowWe'
import { AIDemoCall } from '../components/AIDemoCall'
import { Pricing } from '../components/Pricing'
import { Footer } from '../components/Footer'
import { AnimatedPage } from '../components/AnimatedPage'

export const Landing = () => {
  return (
    <AnimatedPage>
    
    <Hero/>
    <HowWe/>
    <AIDemoCall/>
    {/* <Pricing/> */}
    

    </AnimatedPage>
  )
}